import { useState } from "react";
import { Link, useOutletContext } from "react-router-dom";
import { Mail } from "lucide-react";
import { toast } from "react-toastify";

import { authApi } from "../api/axios";
import IconField from "../components/IconField";

function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const { handleEmailBlur } = useOutletContext();

  const handleForgotPassword = async (e) => {
    e.preventDefault();

    if (!email.trim()) {
      toast.error("Please enter your email address.");
      return;
    }

    setLoading(true);

    try {
      const { data } = await authApi.post("/account/forgetpassword", {
        userName: email.trim(),
      });

      if (data?.success) {
        toast.success(data.message || "Reset link sent to your email.");
        setEmail("");
      } else {
        toast.error(data?.message || "Failed to send reset link.");
      }
    } catch (error) {
      toast.error(
        error.response?.data?.message ||
          error.message ||
          "An error occurred. Please try again.",
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="text-center mb-6">
        <h2 className="text-2xl font-semibold mb-1 mt-6">Forgot Password?</h2>

        <p className="text-gray-500 text-sm">
          Enter your email address and we'll send you a reset link.
        </p>
      </div>

      <form
        noValidate
        onSubmit={handleForgotPassword}
        className="space-y-4 w-full max-w-sm mx-auto"
      >
        <IconField icon={Mail}>
          <input
            type="email"
            name="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            onBlur={handleEmailBlur}
            placeholder="Email"
            className="block w-full border border-gray-300 rounded-lg shadow-sm pl-11 pr-3 py-3 text-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-primaryColor focus:border-transparent bg-white"
            required
          />
        </IconField>

        <button
          type="submit"
          disabled={loading}
          className="w-full flex items-center justify-center bg-primaryColor text-white px-3 py-2 rounded-md text-sm hover:bg-secondaryColor transition-colors duration-300 disabled:cursor-not-allowed"
        >
          {loading ? "Sending..." : "Send Reset Link"}
        </button>

        <Link
          to="/"
          className="block text-center text-sm text-primaryColor hover:underline"
        >
          Back to Login
        </Link>
      </form>
    </>
  );
}

export default ForgotPassword;
